import type { CharacterStay } from "@/data/rail-branches";

const staysByPlace = new WeakMap<
  readonly CharacterStay[],
  ReadonlyMap<string, readonly CharacterStay[]>
>();

/** A loaded book's stays never change, so each site's list is built once. */
export function staysAtPlace(
  stays: readonly CharacterStay[],
  rootPlaceId: string,
): readonly CharacterStay[] {
  let index = staysByPlace.get(stays);
  if (index === undefined) {
    const built = new Map<string, CharacterStay[]>();
    for (const stay of stays) {
      const here = built.get(stay.rootPlaceId);
      if (here === undefined) {
        built.set(stay.rootPlaceId, [stay]);
      } else {
        here.push(stay);
      }
    }
    index = built;
    staysByPlace.set(stays, index);
  }
  return index.get(rootPlaceId) ?? [];
}
